/**
 * Created by WJX on 2017/11/24.
 */
import { comment } from '@/api/ajax.js';
import { mapState } from 'vuex';
import { loadMore } from '@/mixins/loadMore.js';
import Emoji from '@/components/emoji/index.vue';
import list from '@/components/list/defaultList.vue';
import { storageUserInfo, setBeforeRegisterUrl } from '@/utils/storage';
import { hideSomeString } from '@/utils/tools';
import SendGift from './sendGift';
import zanImg from '@/static/img/living/zan.png';
import zanImg1 from '@/static/img/living/zan_no.png';
export default {
  mixins: [loadMore],
  components: {
    Emoji,
    list,
    SendGift
  },
  props: {
    //  1:资讯 2:病例 3:直播录播
    type: {
      default: 1
    },
    isLive: {
      default: false,
      type: Boolean
    },
    name: {
      default: '没有课程名字'
    },
    qaId: {
      default: 0
    },
    isCollection: {
      default: 0
    },
    detail: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      showImg: false,
      showImgImg: '',
      blankHeaderImg: require('@/assets/2114252277uf.png'),
      showGift: false,
      focus: false,
      placeholder: '发布评论', //  (至少2个字，最多200字)
      commentNameList: ['按时间', '按推荐'],
      chooseFlag: false,
      showReply: false, //是否显示回复层
      replyValue: '',
      isOpenEmoji: false,
      fixFlag: 0,
      timer: null,
      listAjax: comment.commentList,
      notUseHasMore: true,
      replying: false, // 防止重复点击
      isZan: false,
      isZanState: false,
      topCommentList: [],
      disableUserList: []
    };
  },
  computed: {
    forEachList() {
      const { topCommentList, disableUserList, listData } = this;
      return [
        ...topCommentList, // 置顶评论
        ...disableUserList.map(i => ({ ...i, isDisableUser: true })), // 禁言记录
        ...listData // 普通评论
      ];
    },
    isAdminComment() {
      // 3 => 管理员评论
      // 4 => 管理员回复
      return item => item.userType == 3 || item.userType == 4;
    }
  },
  methods: {
    hiddenEmojiComponent() {
      this.isOpenEmoji = false;
    },
    isUseEmoji() {
      this.isOpenEmoji = !this.isOpenEmoji;
      this.$nextTick(() => {
        scrollTo(0, document.documentElement.scrollHeight);
      });
    },
    // 获取emoji表情组件传上来的emoji表情
    getEmoji(data) {
      this.replyValue += this.$emoji.get(data);
      this.isOpenEmoji = false;
    },
    // 删除对应的表情及文字
    deleteEmoji(data) {
      if (
        (
          this.replyValue.charAt(this.replyValue.length - 2) +
          this.replyValue.charAt(this.replyValue.length - 1)
        ).match(
          /\ud83c[\udf00-\udfff]|\ud83d[\udc00-\ude4f]|\ud83d[\ude80-\udeff]/g
        ) != null
      )
        this.replyValue = this.replyValue.substr(
          data,
          this.replyValue.length - 2
        );
      else {
        this.replyValue = this.replyValue.substr(
          data,
          this.replyValue.length - 1
        );
      }
    },

    async sendReply() {
      await this.checkUser();
      if (this.isLive) {
        await this.$store.dispatch('living/setWhite', this.$route.params.id);
        const { whiteStatus } = this.$store.state.living;
        if (whiteStatus != 0) {
          return;
        }
      }
      if (this.replying) return;
      if (
        this.replyValue.length <= 200 &&
        // !/^[1]{0,3}$/.test(this.replyValue) &&
        this.replyValue.length > 1
      ) {
        this.isOpenEmoji = false;
        let dataObj = {
          comment: this.replyValue,
          id: this.$route.params.id,
          isLive: this.isLive ? 1 : 0,
          type: this.type < 3 ? this.type : 3 //  3直播 4录播 评论都是3
        };
        this.replying = true;
        try {
          await comment.addComment(dataObj);
          this.replyValue = '';
          this.getList({ init: true, staticRefresh: true });
          this.$refs.listScroll && (this.$refs.listScroll.scrollTop = 0);
          this.$toast('发布成功');
        } catch (e) {}
        this.replying = false;
      } else {
        this.$toast('请输入2~200个字');
      }
    },
    /*
     * 收藏
     * */
    async collection() {
      await this.checkUser();
      let sendData = {
        id: this.$route.params.id,
        collectType: this.type < 3 ? this.type : 3, // 收藏类型  1 资讯 2 病例 3 课程
        status: this.isCollection ? 2 : 1 // 1收藏 2取消
      };
      await comment.userCollect(sendData);
      this.$toast(this.isCollection ? '取消收藏' : '收藏成功');
      this.$emit('event-collection', this.isCollection ? 0 : 1);
    },
    /*
     * 点赞
     * */
    async heartClickHandler(isZan) {
      this.isZan = !isZan;
      if (!this.$refs['zan']) return;
      try {
        // await API.dianzan()
        this.$refs['zan'].src = isZan ? zanImg : zanImg1;
      } catch (err) {
        console.log(err);
      }
    },
    onFocus() {
      this.focus = true;
      this.isOpenEmoji = false;
      this.fixFlag = document.body.scrollTop;
      this.timer = setTimeout(function() {
        //设置一个计时器，时间设置与软键盘弹出所需时间相近
        document.body.scrollTop = document.body.scrollHeight; //获取焦点后将浏览器内所有内容高度赋给浏览器滚动部分高度
      }, 100);
    },
    onBlur() {
      this.onFocus();
      this.focus = false;
      if (this.type > 2) {
        // 个别手机第三方输入法弹出、消失较慢
        setTimeout(function() {
          document.body.scrollTop = document.documentElement.scrollTop = 0;
        }, 200);
      }
    },
    setListStyle() {
      if (this.type < 3) return;
      this.$nextTick(() => {
        try {
          let fHeight = document.querySelector('.footer').offsetHeight;
          let vHeight = (
            document.querySelector('#ele_video') ||
            document.querySelector('#player')
          ).offsetHeight;
          let tHeight = document.querySelector('.tab').offsetHeight;
          let sHeight = document.documentElement.clientHeight;
          if (this.$refs.listScroll) {
            this.$refs.listScroll.style.height =
              sHeight - (tHeight + vHeight + fHeight + 30) + 'px';
          }
        } catch (error) {
          console.log(error);
        }
      });
    },
    clickList() {
      this.showGift = false;
    },
    async sendGif(gift) {
      let time = new Date().getTime();
      // if (time >= this.detail.startDt && time < this.detail.endDt) {
      //   status = 'living';
      // } else if (time < this.detail.startDt) {
      //   status = 'before';
      // } else {
      //   status = 'after';
      // }
      if (this.$store.state.living.livingStatus === 2) {
        await this.checkUser();
        await this.$store.dispatch('living/setWhite', this.$route.params.id);
        if (this.isLive) {
          const { whiteStatus } = this.$store.state.living;
          console.log(whiteStatus);
          if (whiteStatus != 0) {
            return;
          }
        }
        let { fullName, id, phone } = storageUserInfo();
        var giftData = {
          type: 2,
          userName: fullName || hideSomeString(phone) || '',
          userId: id || '',
          userClickTime: new Date().getTime(),
          courseId: 'jhss_' + this.$route.params.id,
          giftType: 1,
          giftCount: 1,
          giftImg: gift.img,
          giftName: gift.name,
          name: fullName || hideSomeString(phone),
          id: id,
          liveEndTime: ''
        };
        window.dmsocket && window.dmsocket.send(JSON.stringify(giftData));
      } else {
        this.$toast(
          this.$store.state.living.livingStatus === 1
            ? '直播还未开始'
            : '直播已结束'
        );
      }
    },
    clickBox() {},
    checkUser() {
      let { id } = storageUserInfo();
      if (!id) {
        setBeforeRegisterUrl();
        this.$router.push({ name: 'register' });
        return Promise.reject();
      }
      return Promise.resolve();
    }
  },
  watch: {
    qaId: {
      immediate: true,
      async handler(v) {
        if (v) {
          this.pageObj.id = v;
          this.pageObj.type = this.type < 3 ? this.type : 3;
          await this.getList({ init: true, staticRefresh: true });
          this.$nextTick(() => {
            this.setListStyle();
          });
        }
      }
    },
    focus(v) {
      this.placeholder = v ? '至少2个字，最多200字' : '发布评论';
    }
  },
  mounted() {},
  beforeDestroy() {},
  created() {
    comment.topCommentList({ id: this.$route.params.id }).then(res => {
      this.topCommentList = res.data.data;
    });
    comment.listDisableUser({ id: this.$route.params.id }).then(res => {
      this.disableUserList = res.data.data;
    });
  }
};
